/**
 * Date-extensions locale Northern Sami [se]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('se', {
    monthNames: ['Ođđajagemánnu','Guovvamánnu','Njukčamánnu','Cuoŋománnu','Miessemánnu','Geassemánnu','Suoidnemánnu','Borgemánnu','čakčamánnu','Golggotmánnu','Skábmamánnu','Juovlamánnu'],
    monthShortNames: ['Ođđj','Guov','Njuk','Cuo','Mies','Geas','Suoi','Borg','čakč','Golg','Skáb','Juov'],
    dayNames: ['Sotnabeaivi','Vuossárga','Maŋŋebárga','Gaskavahkku','Duorastat','Bearjadat','Lávvardat'],
    dayShortNames: ['Sotn','Vuos','Maŋ','Gask','Duor','Bear','Láv']
});
